import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  calculateScrollDepth,
  initializeAnalytics,
  trackPageView,
  trackScrollDepth,
  trackSiteClick,
} from '../services/analytics';

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initializeAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`, document.title);
    window.dispatchEvent(new Event('bhol:pageview'));
  }, [location.pathname, location.search]);

  useEffect(() => {
    const reportedDepths = new Set();
    const thresholds = [50, 90];

    const handleScroll = () => {
      const depth = calculateScrollDepth({
        scrollY: window.scrollY,
        innerHeight: window.innerHeight,
        scrollHeight: document.documentElement.scrollHeight,
      });

      thresholds.forEach((threshold) => {
        if (depth >= threshold && !reportedDepths.has(threshold)) {
          reportedDepths.add(threshold);
          trackScrollDepth(threshold);
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClick = (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const element = event.target.closest('[data-analytics-click], a, button');
      if (!element) {
        return;
      }

      trackSiteClick(element);
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
}

export default AnalyticsTracker;
